<template>
  <div class="wrapper">
    <div style="margin-bottom:20px;">
      <el-button
        @click="handleEdit('',0)"
        type="primary"
        icon="el-icon-plus"
        v-auth="'sys:business:add'"
      >{{$t('common.addNew')}}</el-button>
    </div>
    <div style="margin-bottom:20px;">
      <el-form :inline="true" :model="formSearch" class="demo-form-inline">
        <el-form-item :label="$t('company.companyName')">
          <el-input v-model="formSearch.name" :placeholder="$t('company.companyName')"></el-input>
        </el-form-item>
        <el-form-item label="code">
          <el-input v-model="formSearch.code" placeholder="code"></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.status')">
          <el-select

            v-model="formSearch.status"
            :placeholder="$t('user.userStatus')"
          >
            <el-option :label="$t('common.start')" value="1"></el-option>
            <el-option :label="$t('common.stop')" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmitSearch">{{$t('common.search')}}</el-button>
          <el-button @click="resetSearch">{{$t('common.reset')}}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table border :data="businessLists"  style="width: 100%">
      <el-table-column :label="$t('company.companyName')" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="公司名称" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.companyName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="code" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.code }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="state" :label="$t('common.status')" width="120" align="center">
        <template scope="scope">
          <el-button type="text" v-if="scope.row.status==2" plain>{{$t("common.stop")}}</el-button>
          <el-button type="text" v-if="scope.row.status==1" plain>{{$t("common.start")}}</el-button>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.handle')">
        <template slot-scope="scope">
          <el-button v-auth="'sys:business:edit'" size="mini" @click="handleEdit(scope.row,1)">{{$t("common.edit")}}</el-button>
          <el-button
            type="info"
            size="mini"
            @click="blockUp(scope.row)"
            v-if="scope.row.status==1"
            v-auth="'sys:business:stop'"
          >{{$t("common.stop")}}</el-button>
          <el-button
            type="success"
            size="mini"
            @click="startUsing(scope.row)"
            v-auth="'sys:business:stop'"
            v-if="scope.row.status==2"
          >{{$t("common.start")}}</el-button>
          <el-button
            size="mini"
            type="danger"
            v-auth="'sys:business:edit'"
            @click="handleDelete(scope.$index, scope.row)"
          >{{$t("common.delete")}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 编辑弹窗 -->
    <el-dialog :title="titleName" :visible.sync="showEditBox">
      <el-form :model="form">
        <el-form-item
          v-if="roleSys"
          :label="$t('user.companyChoice')"
          :label-width="formLabelWidth"
          prop="companyId"
        >
          <el-select

            v-model="form.companyId"
            :placeholder="$t('user.companyChoice')"
          >
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="code" prop="code" :label-width="formLabelWidth">
          <el-input v-model="form.code" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('company.companyName')" prop="name" :label-width="formLabelWidth">
          <el-input v-model="form.name" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditBox = false">{{$t("common.cancel")}}</el-button>
        <el-button type="primary" @click="submitData">{{$t("common.ok")}}</el-button>
      </div>
    </el-dialog>
    <div style="margin-top:20px;text-align:right">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10,20,50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalSize"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {
  businessList,
  editbusinessList,
  addbusinessList,
  delbusinessList,
  businessStatus
} from "@/api/sys/business";
import { companyListAll } from "@/api/sys/companyList";
import { Message, MessageBox } from "element-ui";
import { localRead } from "@/utils/tools";
export default {
  data() {
    return {
      userInfo: JSON.parse(
        localRead(this.$route.query.label + "_sys_userInfo")
      ),
      titleName: this.$t("common.edit"),
      businessLists: [],
      showEditBox: false,
      changeType: 1,
      formLabelWidth: "150px",
      currentPage: 1,
      pageSize: 10,
      totalSize: 0,
      form: {
        code: "",
        id: 0,
        name: "",
        companyId: ""
      },
      formSearch: {
        code: "",
        id: 0,
        name: "",
        status: ""
      },
      companyList: "", // 公司列表
      roleSys: false //公司选项是否出现
    };
  },
  created() {
    if (this.userInfo.isBy) {
      this.roleSys = true;
      this.getCompanyList();
    } else {
      this.roleSys = false;
    }
  },
  mounted() {
    this.getbusinessList();
  },
  methods: {
    getbusinessList() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage
      };
      businessList(data).then(res => {
        this.businessLists = res.result.list;
        this.totalSize = res.result.total;
      });
    },
    onSubmitSearch() {
      businessList(this.formSearch).then(res => {
        if (res.code == 0) {
          this.businessLists = res.result.list;
        }
      });
    },
    getCompanyList() {
      companyListAll().then(res => {
        this.companyList = res.result;
      });
    },
    resetSearch() {
      this.formSearch = {};
    },
    handleEdit(row, type) {
        let updateObject;
      updateObject = Object.assign({},row);
      this.changeType = type;
      if (this.changeType == 1) {
        this.form = row;
        this.titleName = this.$t("common.edit");
      } else {
        for (let key in this.form) {
          this.form[key] = "";
        }
        this.titleName = this.$t("common.addNew");
      }
      this.showEditBox = true;
    },
    changeStatus(pram) {
      let data = {
        id: pram.id,
        status: pram.status
      };
      businessStatus(data).then(res => {
        if (res.code == 0) {
          console.log("更改成功");
        }
      });
    },
    startUsing(row) {
      row.status = 1;
      this.changeStatus(row);
    },
    blockUp(row) {
      row.status = 2;
      this.changeStatus(row);
    },
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: this.$t("common.ok"),
        cancelButtonText: this.$t("common.cancel"),
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            delbusinessList(row.id).then(res => {
              if (res.code == 0) {
                this.getbusinessList();
              }
            });
            done();
          }else{
            done();
          }
        }
      })
        .then(() => {
          this.$message({
            type: "success",
            message: this.$t("common.conDelete")
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("common.canDele")
          });
        });
    },
    submitData() {
      if (this.changeType == 1) {
        editbusinessList(this.form).then(res => {
          if (res.code == 0) {
            Message({
              message: this.$t("common.changeSu"),
              type: "success"
            });
          }
          this.getbusinessList();
        });
      } else {
        addbusinessList(this.form).then(res => {
          if (res.code == 0) {
            Message({
              message: this.$t("common.addSu"),
              type: "success"
            });
          }
          this.getbusinessList();
        });
      }

      this.showEditBox = false;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getbusinessList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getbusinessList();
    }
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  margin: 50px;
  border: 1px solid #ebebeb;
  border-radius: 3px;
  transition: 0.2s;
  padding: 20px;
}
</style>
